export const getTableStyle = {
  headerStyle: {
    fontSize: 8,
    fontWeight: 'bold',
    color: 'black',
  },
  tableValueStyle: {
    fontSize: 8,
    color: '#605e5c',
  },
  rightAlignheaderStyle: {
    fontSize: 8,
    fontWeight: 'bold',
    color: 'black',
    textAlign: 'right' as const,
  },

  rightAlignTablevalueStyle: {
    fontSize: 8,
    color: '#605e5c',
    textAlign: 'right' as const,
  },

  rightAlignSingleFlex: {
    flex: 1,
    textAlign: 'right' as const,
  },

  tableHeaderWrapper: {
    flexDirection: 'row' as const,
    marginTop: 10,
    height: 40,
    marginHorizontal: 5,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    borderBottomWidth: 0.2,
  },

  tableBottomHeaderWrapper: {
    flexDirection: 'row' as const,
    height: 40,
    marginHorizontal: 5,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },

  tableRowWrapper: {
    flexDirection: 'row' as const,
    marginHorizontal: 5,
    height: 40,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },
  smallFlex: {
    flex: 0.5,
  },
  singleFlex: {
    flex: 1,
  },
  mediumFlex: {
    flex: 1.5,
  },
  largeFlex: {
    flex: 2,
  },
};
